<template>
    <div class="metal_block mb-4" v-if="options">
        <div class="metal_label" v-if="label">
            <label for="">{{ label }}: </label>
            <span>{{ selected.label }}</span>
        </div>
        <div class="over_flow">
            <div class="metal_flex">
                <div class="metal_box" v-for="opt in options" :key="opt.id" :class="{ 'active': opt.selected }"
                    @click="changeMetal(opt.value)">
                    <img v-if="opt.icon==='white'" width="200" height="200" src="~/assets/metals/white.png" alt="white gold"/>
                    <img v-if="opt.icon==='yellow'" width="200" height="200" src="~/assets/metals/yellow.png" alt="yellow gold"/>
                    <img v-if="opt.icon==='rose'" width="200" height="200" src="~/assets/metals/rose.png" alt="rose gold"/>
                    <!-- <SvgMetalSvg :type="opt.selected ? opt.icon + '_active' : opt.icon" /> -->
                    <span>{{ opt.short_label }}</span>
                </div>
            </div>
        </div>
        <!-- {{options}} -->
    </div>
</template>
<script setup>
const { type, label, data } = defineProps(['type', 'data', 'label'])
const emit = defineEmits(['toggleOption'])
const options = ref(data)
const selected = computed(() => {
    return options.value ? options.value.find((cv) => cv.selected) : null
})
function changeMetal(option) {
    data.filter((item) => {
        if (item.value === option) {
            item.selected = 1
        } else {
            item.selected = 0
        }
    })
    emit('toggleOption', type, option)
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 2px;
    height: 3px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f5f5f5; 
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #c4c4c4; 
}


.metal_label {
    display: flex;
    align-items: center;
}

.metal_label label {
    text-transform: capitalize;
    font-weight: 600;
}

.metal_label span {
    text-transform: capitalize;
    font-weight: 600;
    color: var(--green);
    margin-left: 10px;
}

.metal_label {
    display: flex;
    align-items: center;
}

.metal_label label {
    text-transform: capitalize;
    font-weight: 600;
}

.metal_label span {
    text-transform: capitalize;
    font-weight: 600;
    color: var(--green);
    margin-left: 10px;
}

.metal_flex {
    display: flex;
    align-items: flex-start;
    padding: 2% 0 0;
    gap: 20px;
    max-width: 100%;
    overflow: auto;
}

.metal_box {
    cursor: pointer;
}

.metal_box span {
    color: #606060;
    font-size: 14px;
    text-transform: uppercase;
    min-width: 46px;
    display: inline-block;
    text-align: center;
}

.metal_box.active span {
    color: var(--green);
    font-weight: 600;
}

/* .over_flow {
    overflow-x: scroll;
    overflow-y: hidden;
} */

@media(max-width: 1050px) {
    .metal_flex {
        /* min-width: 450px; */
    }
}

@media(max-width: 767px) {
    .metal_flex {
        padding-bottom: 0;
    }
    
    .metal_box svg.svg-metal {
        /* transform: scale(0.7); */
    }
    
    .metal_label {
        font-size: 14px;
    }
}
</style>